import React, { useState } from 'react';
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      category: "Général",
      questions: [
        {
          question: "Qu'est-ce qu'EM Coaching ?",
          answer: "EM Coaching est un centre de coaching sportif professionnel situé à Berchem-Sainte-Agathe. Nous proposons des séances de coaching personnalisé (privé, duo ou groupe) avec Coach Massa, fort de plus de 17 ans d'expérience dans le sport."
        },
        {
          question: "Où se trouve la salle ?",
          answer: "Nous sommes situés à l'Av. de la Basilique 14, 1082 Berchem-Sainte-Agathe. La salle est facilement accessible en transport en commun et dispose d'un parking à proximité."
        },
        {
          question: "Quels sont les horaires d'ouverture ?",
          answer: "Du lundi au vendredi : 09:00 - 12:00 et 16:30 - 19:30. Le samedi : 09:00 - 12:00 (matin uniquement). Fermé le dimanche."
        }
      ]
    },
    {
      category: "Tarifs & Packs",
      questions: [
        {
          question: "Combien coûte une séance ?",
          answer: "Nous proposons des packs de séances adaptés à vos besoins. Les tarifs varient selon le type de coaching (privé, duo ou groupe) et le nombre de séances choisies. Contactez-nous pour obtenir un devis personnalisé : 0489 82 27 09"
        },
        {
          question: "Quels packs de séances proposez-vous ?",
          answer: "Nous proposons des packs de 8, 12, 16 ou 20 séances. Plus le pack est important, plus le tarif par séance est avantageux. Chaque pack est valable jusqu'à épuisement des séances."
        },
        {
          question: "Comment puis-je payer ?",
          answer: "Nous acceptons les paiements par virement bancaire, en espèces ou par Bancontact. Après réception du paiement, vous recevrez un code d'activation pour accéder à votre espace client et réserver vos séances."
        },
        {
          question: "Que se passe-t-il si j'ai terminé mon pack ?",
          answer: "Lorsque votre pack est terminé, votre compte devient inactif. Vous recevrez une notification quand il vous reste 2 séances. Pour continuer, contactez Coach Massa qui vous générera un nouveau code d'activation pour un nouveau pack."
        }
      ]
    },
    {
      category: "Réservations",
      questions: [
        {
          question: "Comment réserver une séance ?",
          answer: "Une fois votre code d'activation entré, connectez-vous à votre espace client. Vous pourrez y réserver vos séances en sélectionnant les créneaux horaires disponibles dans le planning. Vous recevrez une confirmation par email."
        },
        {
          question: "Puis-je annuler ou modifier une réservation ?",
          answer: "Oui, vous pouvez contacter Coach Massa par téléphone ou WhatsApp (0489 82 27 09) pour modifier ou annuler une séance. Nous vous demandons de prévenir au moins 24h à l'avance."
        },
        {
          question: "Combien de créneaux puis-je réserver à l'avance ?",
          answer: "Vous pouvez réserver plusieurs créneaux en fonction des séances restantes dans votre pack. Le système vous indique automatiquement combien de créneaux vous pouvez sélectionner."
        },
        {
          question: "Je n'ai pas reçu de confirmation de réservation, que faire ?",
          answer: "Vérifiez d'abord vos spams. Si vous ne trouvez rien, connectez-vous à votre espace client pour vérifier que vos réservations apparaissent bien. Si le problème persiste, contactez-nous au 0489 82 27 09."
        }
      ]
    },
    {
      category: "Types de Coaching",
      questions: [
        {
          question: "Quelle est la différence entre coaching privé, duo et groupe ?",
          answer: "Coaching Privé : Séance individuelle 1-on-1 avec le coach, entièrement personnalisée. Coaching Duo : Séance à 2 personnes (vous + un ami/partenaire), plus abordable tout en restant personnalisé. Coaching Groupe : Séance en petit groupe (max 4-5 personnes), ambiance motivante et conviviale."
        },
        {
          question: "Je débute, quel coaching me conseillez-vous ?",
          answer: "Si vous débutez, nous recommandons le coaching privé pour les premières séances afin d'apprendre les bonnes bases. Vous pourrez ensuite passer en duo ou groupe si vous le souhaitez. Coach Massa s'adapte à tous les niveaux !"
        },
        {
          question: "Proposez-vous un programme nutrition ?",
          answer: "Oui ! Coach Massa peut vous accompagner avec des conseils nutrition personnalisés pour optimiser vos résultats. N'hésitez pas à en discuter lors de votre première séance."
        }
      ]
    },
    {
      category: "Inscription & Compte",
      questions: [
        {
          question: "Comment créer mon compte ?",
          answer: "Cliquez sur \"Connexion\" puis \"Créer un compte\" en haut du site. Remplissez le formulaire d'inscription avec vos informations. Une fois inscrit, contactez Coach Massa pour obtenir votre code d'activation."
        },
        {
          question: "J'ai perdu mon code d'activation, que faire ?",
          answer: "Contactez Coach Massa directement au 0489 82 27 09 ou par WhatsApp. Il pourra vous renvoyer votre code ou en générer un nouveau si nécessaire."
        },
        {
          question: "Je n'arrive pas à me connecter, que faire ?",
          answer: "Vérifiez que vous utilisez la bonne adresse email et le bon mot de passe. Si vous avez oublié votre mot de passe, contactez-nous. Assurez-vous également que votre compte a bien été activé avec un code."
        }
      ]
    },
    {
      category: "Matériel & Équipement",
      questions: [
        {
          question: "Dois-je apporter mon propre matériel ?",
          answer: "Non, tout le matériel nécessaire est disponible sur place (haltères, barres, élastiques, tapis, etc.). Apportez simplement une tenue de sport confortable, des baskets et une bouteille d'eau."
        },
        {
          question: "Y a-t-il des vestiaires et des douches ?",
          answer: "Oui, la salle dispose de vestiaires. Pour plus d'informations sur les équipements disponibles, consultez notre page Installations ou contactez-nous."
        }
      ]
    }
  ];

  const toggleQuestion = (categoryIndex, questionIndex) => {
    const index = `${categoryIndex}-${questionIndex}`;
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-black">
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-zinc-950 via-black to-red-950/20">
        <div className="container mx-auto px-6">
          <div className="max-w-3xl mx-auto text-center">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-red-600 rounded-full mb-6">
              <HelpCircle className="w-10 h-10 text-white" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Questions Fréquentes
            </h1>
            <p className="text-xl text-gray-400">
              Vous avez des questions ? Nous avons les réponses ! Retrouvez toutes les informations utiles sur EM Coaching.
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Content */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            {faqs.map((category, categoryIndex) => (
              <div key={categoryIndex} className="mb-12">
                <h2 className="text-2xl font-bold text-white mb-6 flex items-center">
                  <span className="w-2 h-8 bg-red-600 mr-3"></span>
                  {category.category}
                </h2>
                <div className="space-y-4">
                  {category.questions.map((faq, questionIndex) => {
                    const isOpen = openIndex === `${categoryIndex}-${questionIndex}`;
                    return (
                      <div
                        key={questionIndex}
                        className="bg-zinc-900 border border-zinc-800 rounded-lg overflow-hidden hover:border-zinc-700 transition-colors"
                      >
                        <button
                          onClick={() => toggleQuestion(categoryIndex, questionIndex)}
                          className="w-full px-6 py-4 flex items-center justify-between text-left group"
                        >
                          <span className="text-white font-medium pr-4 group-hover:text-red-600 transition-colors">
                            {faq.question}
                          </span>
                          {isOpen ? (
                            <ChevronUp className="w-5 h-5 text-red-600 flex-shrink-0" />
                          ) : (
                            <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" />
                          )}
                        </button>
                        {isOpen && (
                          <div className="px-6 pb-4">
                            <p className="text-gray-400 leading-relaxed">
                              {faq.answer}
                            </p>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-16 bg-gradient-to-br from-red-950/20 to-black border-t border-zinc-800">
        <div className="container mx-auto px-6">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-white mb-4">
              Vous n'avez pas trouvé la réponse ?
            </h2>
            <p className="text-gray-400 mb-8">
              N'hésitez pas à nous contacter directement, Coach Massa se fera un plaisir de répondre à toutes vos questions !
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:0489822709"
                className="inline-flex items-center justify-center px-8 py-4 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-lg transition-colors"
              >
                📞 0489 82 27 09
              </a>
              <a
                href="https://wa.me/32489822709?text=Bonjour,%20j'ai%20une%20question%20sur%20EM%20Coaching"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-8 py-4 bg-[#25D366] hover:bg-[#20BA5A] text-white font-semibold rounded-lg transition-colors"
              >
                💬 WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
